import {RouteConfig} from '@dfl/react-security';
import {lazy} from 'react';

import {TermsConditions} from "modules/anonymous";

const loadMainApp = () => import('routes/MainApp');
export const MainApp = lazy(loadMainApp);

const loadCMSApp = () => import('routes/CMSApp');
export const CMSApp = lazy(loadCMSApp);


const loadAuthApp = () => import('routes/AuthApp');
export const AuthApp = lazy(loadAuthApp);


export const routes: RouteConfig = {
    Auth: {
        path: '/auth/*',
        onlyAnonymous: true,
        component: AuthApp
    },
    anonymous: {
        path: '/terms-conditions',
        component: TermsConditions
    },
    CMSBuilderLayout: {
        path: '/cms/pages/builder/:id',
        authenticated: true,
        component: CMSApp
    },

    MainLayout: {
        path: '*',
        authenticated: true,
        component: MainApp
    }
};
